"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'tokenKey',
                type: 'string',
            },
        ],
        name: 'SetLegacyRecords',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'string', name: 'network', type: 'string' },
        ],
        name: 'SetNetworkFamily',
        type: 'event',
    },
    {
        inputs: [],
        name: 'NAME',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'VERSION',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string[]', name: 'networks', type: 'string[]' },
            { internalType: 'string[]', name: 'families', type: 'string[]' },
        ],
        name: 'addBlockchainNetworks',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string[]', name: 'networks', type: 'string[]' },
            { internalType: 'string', name: 'family', type: 'string' },
        ],
        name: 'addBlockchainNetworks',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string[]', name: 'keys', type: 'string[]' },
            { internalType: 'string[][]', name: 'legacyKeys', type: 'string[][]' },
        ],
        name: 'addLegacyRecords',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'exists',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'key', type: 'string' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'get',
        outputs: [{ internalType: 'string', name: 'value', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'network', type: 'string' },
            { internalType: 'string', name: 'token', type: 'string' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getAddress',
        outputs: [{ internalType: 'string', name: 'addr', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'network', type: 'string' },
            { internalType: 'string', name: 'token', type: 'string' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getAddressKey',
        outputs: [{ internalType: 'string', name: 'key', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'network', type: 'string' },
            { internalType: 'string', name: 'token', type: 'string' },
        ],
        name: 'getAddressKeys',
        outputs: [{ internalType: 'string[]', name: 'keys', type: 'string[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'getApproved',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'keyHash', type: 'uint256' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getByHash',
        outputs: [
            { internalType: 'string', name: 'key', type: 'string' },
            { internalType: 'string', name: 'value', type: 'string' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string[]', name: 'keys', type: 'string[]' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getData',
        outputs: [
            { internalType: 'address', name: 'resolver', type: 'address' },
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'string[]', name: 'values', type: 'string[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256[]', name: 'keyHashes', type: 'uint256[]' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getDataByHash',
        outputs: [
            { internalType: 'address', name: 'resolver', type: 'address' },
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'string[]', name: 'keys', type: 'string[]' },
            { internalType: 'string[]', name: 'values', type: 'string[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256[]', name: 'keyHashes', type: 'uint256[]' },
            { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
        ],
        name: 'getDataByHashForMany',
        outputs: [
            { internalType: 'address[]', name: 'resolvers', type: 'address[]' },
            { internalType: 'address[]', name: 'owners', type: 'address[]' },
            { internalType: 'string[][]', name: 'keys', type: 'string[][]' },
            { internalType: 'string[][]', name: 'values', type: 'string[][]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string[]', name: 'keys', type: 'string[]' },
            { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
        ],
        name: 'getDataForMany',
        outputs: [
            { internalType: 'address[]', name: 'resolvers', type: 'address[]' },
            { internalType: 'address[]', name: 'owners', type: 'address[]' },
            { internalType: 'string[][]', name: 'values', type: 'string[][]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string[]', name: 'keys', type: 'string[]' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getMany',
        outputs: [{ internalType: 'string[]', name: 'values', type: 'string[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256[]', name: 'keyHashes', type: 'uint256[]' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getManyByHash',
        outputs: [
            { internalType: 'string[]', name: 'keys', type: 'string[]' },
            { internalType: 'string[]', name: 'values', type: 'string[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'contract IUNSRegistry',
                name: 'unsRegistry',
                type: 'address',
            },
            {
                internalType: 'contract ICNSRegistry',
                name: 'cnsRegistry',
                type: 'address',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        name: 'isApprovedForAll',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'spender', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'isApprovedOrOwner',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes[]', name: 'data', type: 'bytes[]' }],
        name: 'multicall',
        outputs: [{ internalType: 'bytes[]', name: 'results', type: 'bytes[]' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string[]', name: 'labels', type: 'string[]' }],
        name: 'namehash',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'ownerOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' }],
        name: 'ownerOfForMany',
        outputs: [{ internalType: 'address[]', name: 'owners', type: 'address[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'registryOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'resolverOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'addr', type: 'address' }],
        name: 'reverseNameOf',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'addr', type: 'address' }],
        name: 'reverseOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'addr', type: 'address' }],
        name: 'setOwner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'tokenURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
